import { render, staticRenderFns } from "./Certnum.vue?vue&type=template&id=506c234c&"
import script from "./Certnum.vue?vue&type=script&lang=js&"
export * from "./Certnum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports